import React, { useRef } from "react";
import SwiperCore, { Navigation, Zoom } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// import { useStaticQuery, graphql } from "gatsby";
import 'swiper/swiper-bundle.min.css';
import Img from "gatsby-image";
import { imageSliderStyle } from "./imageSliderStyle";
import { imageFadeDuration } from "../../constants/componentConstants";

SwiperCore.use([Navigation, Zoom]);

const ImageSlider = ({ imageData, startSlide = 0 }) => {
  // console.log(imageData);
  const prevClass = imageSliderStyle.navPrev;
  const nextClass = imageSliderStyle.navNext;
  // console.log(`css-${nextClass.name}`);

  const navPrevRef = useRef(null);
  const navNextRef = useRef(null);

  const onZoomChange = (swiper, scale) => {
    console.log(scale);
    if (scale > 1) {
      navPrevRef.current.style.display = "none";
      navNextRef.current.style.display = "none";
    } else {
      navPrevRef.current.style.display = "block";
      navNextRef.current.style.display = "block";
    }
  }
  return (
    <Swiper
      initialSlide={startSlide}
      loop={true}
      zoom={{ maxRatio: 2 }}
      navigation={{
        prevEl: `.css-${prevClass.name}`,
        nextEl: `.css-${nextClass.name}`,
      }}
      onSlideChange={() => console.log('slide change')}
      onSwiper={(swiper) => console.log(swiper)}
      onZoomChange={onZoomChange}
    >
      {imageData.edges.map((image, index) => (
        <SwiperSlide key={index}>
          <div css={imageSliderStyle.slideInner}>
            <div className="swiper-zoom-container">
              <div css={imageSliderStyle.zoomTarget} className="swiper-zoom-target">
                <Img
                  fluid={image.node.childImageSharp.fluid}
                  alt={image.node.base.split(".")[0]} // only use section of the file extension with the filename
                  style={{ width: "100%", maxHeight: "100%" }}
                  imgStyle={{ objectFit: "contain" }}
                  durationFadeIn={imageFadeDuration}
                />
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
      <div css={imageSliderStyle.navPrev} ref={navPrevRef} />
      <div css={imageSliderStyle.navNext} ref={navNextRef} />
    </Swiper>
  );
}

export default ImageSlider
